import React           from 'react';
import useDesignTokens from '@/hooks/useDesignTokens';

const MIN_HEIGHT = 0.25;
const MAX_HEIGHT = 0.95;

type Drag = { y: number; height: number; total: number };

/** Poignée d'un panneau ouvert depuis le bas : la tirer règle la part de l'éditeur qu'il occupe. */
export default function SheetHandle({ height, onChange }: { height: number; onChange: (height: number) => void }) {
	const tokens = useDesignTokens();
	const drag = React.useRef<Drag | null>(null);

	const end = () => {
		drag.current = null;
	};

	return (
		<div
			role="separator"
			aria-orientation="horizontal"
			aria-label="Redimensionner le panneau"
			onPointerDown={event => {
				const editor = event.currentTarget.closest('.editor');

				drag.current = { y: event.clientY, height, total: editor?.clientHeight || window.innerHeight };
				event.currentTarget.setPointerCapture(event.pointerId);
			}}
			onPointerMove={event => {
				if (!drag.current) return;

				const { y, height: startHeight, total } = drag.current;
				onChange(Math.min(MAX_HEIGHT, Math.max(MIN_HEIGHT, startHeight + (y - event.clientY) / total)));
			}}
			onPointerUp={end}
			onPointerCancel={end}
			style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 4px', touchAction: 'none', cursor: 'ns-resize' }}
		>
			<span style={{ width: 36, height: 4, borderRadius: 2, background: tokens.border.default }} />
		</div>
	);
}
